// A closed <details> is invisible to an in-page link: following #sticker-prices would scroll to a panel
// that is still shut. This opens the <details> a hash points at - on load (arriving from another page, e.g.
// /features -> /plans#sticker-prices) and on every later hash change or same-page link click.
(function () {
    function openTarget() {
        var id = decodeURIComponent((location.hash || "").slice(1));
        if (!id) return;
        var el = document.getElementById(id);
        if (el && el.tagName === "DETAILS" && !el.open) {
            el.open = true;
            el.scrollIntoView({ block: "start" });
        }
    }

    document.addEventListener("DOMContentLoaded", openTarget);
    window.addEventListener("hashchange", openTarget);

    // Clicking a link to the hash we are ALREADY on fires no hashchange, so handle the click too.
    document.addEventListener("click", function (e) {
        var link = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
        if (link) setTimeout(openTarget, 0);
    });
})();
